'use client'

import { Dispatch, ReactNode, SetStateAction, useEffect } from 'react'
import styles from './modal.module.scss'

export type ModalProps = {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  className?: string
  children?: ReactNode
}

const Modal = ({ show, setShow, children, className }: ModalProps) => {
  useEffect(() => {
    if (!show) return

    document.body.style.overflow = 'hidden'

    return () => {
      document.body.style.overflow = ''
    }
  }, [show])

  if (!show) return null

  return (
    <div className={styles.modalContainer} onClick={() => setShow(false)}>
      <div className={className} onClick={e => e.stopPropagation()}>
        {children}
      </div>
    </div>
  )
}

export default Modal
